import { IWebsiteBuildingFeatures } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemFeatures extends WebsiteBuilderItemBase {
    name = 'Amenity Showcase';
    navName = 'Amenity Showcase';
    navLink = 'amenityShowcase';
    isShowInMenu = true;
    isHomePagePart = false;

    type: string = 'list';
    fileIsOver: boolean = false;
    buildingFeaturesImages: any[] = [];
    buildingFeaturesImagesSplitted: any[] = [];

    get isDisable(): boolean {
        return !this.buildingFeaturesImages.length;
    }

    set value(item: IWebsiteBuildingFeatures) {
        this.isPresent = item.status;
        this.type = item.type;
        this.buildingFeaturesImages = item.buildingFeaturesImages;
        this.buildingFeaturesImagesSplitted = item.buildingFeaturesImages; // todo: fix it
        this.priority = item.priority;
    }

    get value(): IWebsiteBuildingFeatures {
        return {
            type: this.type,
            buildingFeaturesImages: this.buildingFeaturesImages.map(({captionText, descriptionText, imageUrl, priority}) => ({captionText, descriptionText, imageUrl, priority})),
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-features.ts